import { NavLink } from 'react-router-dom';
import { Home, BarChart3, Diamond, Plus, Receipt, Gem, DollarSign, Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';
import { generateRouteUrl, navigateToRoute } from '@/utils/environment-urls';

const MobileBottomNav = () => {
  const leftNavItems = [
    {
      name: 'Início',
      icon: Home,
      route: '/home',
      isReactRoute: true
    },
    {
      name: 'Vendas',
      icon: Receipt,
      route: '/minhas-vendas',
      isReactRoute: true // React route
    }
  ];

  const rightNavItems = [
    {
      name: 'Recompensas',
      icon: Gem,
      route: '/loja-recompensas',
      isReactRoute: true
    },
    {
      name: 'Ranking',
      icon: Trophy,
      route: '/ranking-vendas', // Ranking de Vendas
      isReactRoute: true // React route
    }
  ];

  const renderNavItem = (item: typeof leftNavItems[0]) => {
    // Se for rota do React, usa NavLink normal
    if (item.isReactRoute) {
      return (
        <NavLink
          key={item.route}
          to={item.route}
          className={({ isActive }) => cn(
            "flex flex-col items-center gap-1 p-2 rounded-lg transition-colors min-w-[60px]",
            isActive 
              ? "text-primary bg-primary/10" 
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          <item.icon className="w-5 h-5 flex-shrink-0" />
          <span className="text-[10px] font-medium text-center leading-tight">{item.name}</span>
        </NavLink>
      );
    } else {
      // Se for rota do Angular, usa navegação externa
      const handleAngularNavigation = (e: React.MouseEvent) => {
        e.preventDefault();
        navigateToRoute(item.route, false); // false = Angular route
      };

      return (
        <a
          key={item.route}
          href={generateRouteUrl(item.route, 'angular')}
          onClick={handleAngularNavigation}
          className="flex flex-col items-center gap-1 p-2 rounded-lg transition-colors text-muted-foreground hover:text-foreground min-w-[60px]"
        >
          <item.icon className="w-5 h-5 flex-shrink-0" />
          <span className="text-[10px] font-medium text-center leading-tight">{item.name}</span>
        </a>
      );
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-40 lg:hidden">
      <div className="flex items-center justify-center py-2 px-2 relative min-h-[70px]">
        {/* Container para todos os itens */}
        <div className="flex items-end justify-between w-full max-w-sm mx-auto">
          {/* Navegação esquerda */}
          <div className="flex gap-2">
            {leftNavItems.map((item) => renderNavItem(item))}
          </div>

          {/* Botão central destacado de Nova Venda */}
          <div className="flex flex-col items-center -mt-2 -translate-y-3 scale-110">
            <NavLink
              to="/nova-venda"
              className="flex items-center justify-center w-12 h-12 bg-primary hover:bg-primary-hover rounded-full shadow-lg transition-all duration-200 hover:scale-105"
            >
              <DollarSign className="w-6 h-6 text-white" />
            </NavLink>
            <div className="text-[10px] font-medium text-center mt-1 text-primary whitespace-nowrap">
              Nova Venda
            </div>
          </div>

          {/* Navegação direita */}
          <div className="flex gap-2">
            {rightNavItems.map((item) => renderNavItem(item))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MobileBottomNav;